import { useNavigate } from 'react-router-dom';
import { parseDate, toMplatBackendDate, toMplatDate, translit1 } from '../../../components/common';
import { useAuth, useLanguage } from '../../../hooks';
import { News } from '../../../services/content_v1';


interface NewsItemProps {
    news: News,
    showTopic?: boolean,
    hideSummary?: boolean,
    hideDetail?: boolean,
    horizontal?: boolean,
    big?: boolean,
    preview?: boolean,
    w100?: boolean,
}

export function NewsItem({ news, showTopic, hideSummary, hideDetail, horizontal, big, preview, w100 }: NewsItemProps) {
    const lang = useLanguage();
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <article
            className={`welcome-news__item${horizontal ? ' _horizontal' : ''}${big ? ' _big' : ''}`}
            onClick={() => navigate(!user ? `/public-news/${news.id}` : `/news/${news.id}`)}
            style={{ width: w100 ? '100%' : undefined }}
        >
            <div className="welcome-news__item-image">
                {news.files.length > 0 && <img src={news.files.at(0)} loading="lazy" alt="" />}
            </div>
            <div className="welcome-news__item-body">
                <div className="welcome-news__item-info">
                    {showTopic && news.topics.map((topic) => <span key={topic.id} className="welcome-news__item-label">{topic.title}</span>)}
                    <h3 className="welcome-news__item-heading">
                        <a href={`/${lang}/public-news/${news.id}_${translit1(news.title) || ''}`} onClick={(e) => preview && e.preventDefault()}>{news.title}</a>
                    </h3>
                    {!hideSummary && <p className="welcome-news__item-copy">{news.summary}</p>}
                </div>
                {!hideDetail && <div className="welcome-news__item-cta">
                    <time className="welcome-news__item-date" dateTime={toMplatBackendDate(parseDate(news.published), true)}>{toMplatDate(news.published, true)}</time>
                    {/* <Link to={!user ? `/public-news/${news.id}` : `/news/${news.id}`} className="link-accent" onClick={(e) => preview && e.preventDefault()}>
                        <Trans>account:DETAILS</Trans><Details />
                    </Link> */}
                </div>}
            </div>
        </article>
    )
}
